class ApiConfig {
  static getApiHost(): string {
    const stagingHost = process.env.REACT_APP_API_HOST_STAGING;
    const localHost = process.env.REACT_APP_API_HOST;
    const port = process.env.REACT_APP_API_PORT;

    if (stagingHost && stagingHost !== '') {
      return `${stagingHost}:${port}`;
    }

    if (localHost && port) {
      return `${localHost}:${port}`;
    }

    throw new Error('API host configuration is missing.');
  }
}

export default ApiConfig;
